const PROVIDER_TYPOS = {
  gmial: 'gmail',
  gmal: 'gmail',
  gmai: 'gmail',
  gamil: 'gmail',
  gnail: 'gmail',
  gmail: 'gmail',
  hotmial: 'hotmail',
  hotmal: 'hotmail',
  hotmai: 'hotmail',
  hotmail: 'hotmail',
  outlok: 'outlook',
  oulook: 'outlook',
  outllook: 'outlook',
  outlook: 'outlook',
  yaho: 'yahoo',
  yaoo: 'yahoo',
  yahooo: 'yahoo',
  yahoo: 'yahoo',
  icoud: 'icloud',
  icloud: 'icloud',
};

const COM_TYPOS = ['con', 'cmo', 'comm', 'comn', 'om'];

export default function emailTypoSuggestion(email) {
  const atIndex = email.lastIndexOf('@');
  if (atIndex < 1) { return null; }

  const domain = email.slice(atIndex + 1).toLowerCase();
  const parts = domain.split('.');
  if (parts.length >= 2 && parts[parts.length - 1] === 'con') {
    const provider = parts.length === 2 && Object.prototype.hasOwnProperty.call(PROVIDER_TYPOS, parts[0]) ? PROVIDER_TYPOS[parts[0]] : null;
    const correctedDomain = provider ? `${provider}.com` : `${domain.slice(0, -3)}com`;
    return `${email.slice(0, atIndex)}@${correctedDomain}`;
  }
  if (parts.length !== 2) { return null; }

  const [provider, extension] = parts;
  const correctedProvider = Object.prototype.hasOwnProperty.call(PROVIDER_TYPOS, provider) ? PROVIDER_TYPOS[provider] : null;
  if (!correctedProvider || (extension !== 'com' && !COM_TYPOS.includes(extension))) { return null; }

  const correctedDomain = `${correctedProvider}.com`;
  return domain === correctedDomain ? null : `${email.slice(0, atIndex)}@${correctedDomain}`;
}
